<script lang="ts">
  import { Modal, Button } from "flowbite-svelte";
  import { createEventDispatcher } from "svelte";
  import { deleteCustomer, deleteProject, deleteUser } from "../../services/api/data-handler.js";
  import { logInfo, logError, logWarning } from "../../services/logging/log-handler.js";

  export let open = false;
  export let objectType: "customer" | "project" | "user";
  export let object: any;

  const dispatch = createEventDispatcher();
  let isDeleting = false;

  $: title = "Delete " + toProperCase(objectType);
  $: if (open) {
  }

  async function handleDelete() {
    isDeleting = true;
    let result = false;
    
    try {
      if (objectType === "customer") {
          result = await deleteCustomer(object.customer_id);
      } else if (objectType === "project") {
          result = await deleteProject(object.project_id);
      } else if (objectType === "user") {
          result = await deleteUser(object.user_id);
      }
      
      dispatch("delete", { result });
      open = false;
    } catch (error) {
      logError(error, "DeleteObjectDialog", undefined, { message: "Delete operation failed" });
      dispatch("delete", { result: false, error });
    } finally {
      isDeleting = false;
    }
  }

  function handleCancel() {
    open = false;
    dispatch("cancel");
  }

  function toProperCase(str: string) {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }
</script>

<Modal
  {title}
  bind:open
  class="dialog"
  backdropClass="dialog-backdrop fixed inset-0 bg-gray-900 bg-opacity-50 dark:bg-opacity-80"
  dialogClass="dialog-content fixed top-0 start-0 end-0 h-modal md:inset-0 md:h-full p-2 flex"
  size="xs"
  autofocus
  placement="center"
>
  <div class="text-left">
    <div class="mb-2 text-xs font-normal text-gray-500 dark:text-gray-400">
      Are you sure you want to delete this {objectType}?
    </div>
  </div>
  <svelte:fragment slot="footer">
    <Button
      class="primary-button"
      on:click={handleDelete}
      disabled={isDeleting}
      data-testid="delete-object-dialog-yes-button">
      {#if isDeleting}
        <svg class="animate-spin -ml-1 mr-3 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        Deleting...
      {:else}
        Yes, I'm sure
      {/if}
    </Button>
    <Button
      class="secondary-button"
      on:click={handleCancel}
      disabled={isDeleting}
      data-testid="delete-object-dialog-no-button">No, cancel</Button
    >
  </svelte:fragment>
</Modal>
